module.exports = __webpack_public_path__ + "static/media/confirmado1.f2c82009.gif";